import { useContext } from 'react';
import './style.scss';
import { ReactComponent as UploadPlus } from '../../upload-plus.svg';
import { ReactComponent as UploadX } from '../../upload-x.svg';
import { FormDataContext } from '../FormDataProvider';

function MeritsStep() {

    const { formData, handleFileChange, handleFileRemove, updateMultiSelectData, updateFormData } = useContext(FormDataContext);

  return (
    <div className="merits-step">
      <h2>Arbetsprover/meriter</h2>
      <p className="desc">Du som inte har en examen från en godkänd utbildning, är student eller är anställd behöver bifoga nedanstående intyg/arbetsprover, för att vi ska kunna bedöma om du är yrkesverksam.</p>

    <div className="form-info-box green">
        <ul style={{listStyle:"decimal"}}>
            <li><span>Beskrivning av din verksamhet</span></li>
            <li><span>Bilder på fem uppdrag utförda under de senaste tre åren med tillhörande fakturor eller motsvarande bevis på att det är ett professionellt uppdrag.<br /><br />

            För varje uppdrag behöver nedanstående framgå:<br />
            Vem var beställare?<br />
            Vilken var din roll i arbetet?</span></li>
        </ul>
        <p className="disclaimer">Observera att uppdrag från privatpersoner inte beaktas vid bedömningen av arbetsproverna. Vårt invalsnämnd tar en helhetsbedömning av din ansökan för att fatta beslut om inträde i föreningen.</p>
    </div>

    <h3>Kompletterande information</h3>
    <label className="full">
        <div className="label-description">Typ av verksamhet</div>
        <div className="multi-select" multi-select="true" name="business_type" onClick={(e) => updateMultiSelectData(e)} required>
            <div className="multi-select-item">
            <label>
                <input type="checkbox" id="company" value="enskild" /><span>Enskild firma</span>
            </label>
            </div>
            <div className="multi-select-item">
            <label>
                <input type="checkbox" id="ab" value="ab" /><span>Driver AB</span>
            </label>
            </div>
            <div className="multi-select-item">
            <label>
                <input type="checkbox" id="trading" value="hb" /><span>Handelsbolag</span>
            </label>
            </div>
            <div className="multi-select-item">
            <label>
                <input type="checkbox" id="self_employment" value="self-employed" /><span>Egen anställning för fakturering (ex Frilans finans)</span>
            </label>
            </div>
            <div className="multi-select-item">
            <label>
                <input type="checkbox" id="other" value="other" /><span>Annat</span>
            </label>
            </div>
        </div>
    </label>
    {formData && formData['business_type'] != undefined && formData['business_type'] == 'other' &&<label className="full">
        Annan verksamhet
        <input type="text" name="business_type_custom" placeholder="Annan verksamhet" onChange={(e) => updateFormData(e)} />
    </label>}
    <label className="full dropdown">
        Sysselsättningsgrad
        <select name="employment_rate" onChange={(e) => updateFormData(e)} >
            <option value="none" defaultValue={''} disabled><span>Välj ...</span></option>
            <option value="less-25">Mindre än 25%</option>
            <option value="25">25%</option>
            <option value="50">50%</option>
            <option value="75">75%</option>
            <option value="100">100%</option>
        </select>
    </label> 

      <p>Sammanställ din ansökan med beskrivning av din verksamhet, bilder och beskrivning av uppdragen med tillhörande fakturor i en och samma PDF.</p>
        <form>
            <label className="full">
            <div className="file-upload">
                <UploadPlus />
                <h3>Ladda upp dina filer</h3>
                <span>Eller välj mapp. pdf, png, jpg eller jpeg. Max 10mb.</span>
                <input type="file" name="merits_files" multiple accept="application/pdf, image/png, image/jpeg, image/jpg" className="hidden" onChange={(e) => handleFileChange(e)} required />
            </div>
            </label>
            {formData && formData['merits_files'] != undefined && formData['merits_files'].length && <div className="file-upload-list">
            <p>Uppladdade filer</p>
            {formData['merits_files'].map((file, index) => (
                <div className="file-upload-list-item" key={index}>
                    <div className="file-upload-list-item-file">
                        <span>{file.name} {file.material_pid && file.material_pid}</span>
                        <UploadX name="merits_files" pid={file.material_pid && file.material_pid} onClick={(e) => handleFileRemove(e)} />
                    </div>
                </div>
            ))}
            </div>}
        </form>
    </div>
  );
}

export default MeritsStep;
